(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dual-banner-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.custom-banner-slider');
    
    sliders.forEach(slider => {
        const slides = slider.querySelectorAll('.banner-slide');
        const dots = slider.querySelectorAll('.slider-dot');
        const prevArrow = slider.querySelector('.slider-arrow.prev');
        const nextArrow = slider.querySelector('.slider-arrow.next');
        const sliderContainer = slider.querySelector('.banner-slider');
        
        const autoplay = slider.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 5000;
        const pauseOnHover = slider.dataset.pauseHover === 'true';
        const enableDrag = slider.dataset.enableDrag === 'true';
        const transitionEffect = slider.dataset.transition || 'slide';
        
        let currentIndex = 0;
        let autoplayInterval;
        let touchStartX = 0;
        let touchEndX = 0;
        let isAnimating = false;
        
        // Function to show a specific slide
        function showSlide(index) {
            if (isAnimating) return;
            isAnimating = true;
            
            // Handle index bounds
            if (index < 0) index = slides.length - 1;
            if (index >= slides.length) index = 0;
            
            // Mark current slide as previous
            slides[currentIndex].classList.add('prev');
            slides[currentIndex].classList.remove('active');
            
            // Update current index
            currentIndex = index;
            
            // Update slides
            slides[currentIndex].classList.add('active');
            slides[currentIndex].classList.remove('prev');
            
            // Update dots
            dots.forEach((dot, i) => {
                dot.classList.toggle('active', i === currentIndex);
            });
            
            // Allow next animation after transition completes
            setTimeout(() => {
                isAnimating = false;
                // Clean up prev class from all slides except current
                slides.forEach((slide, i) => {
                    if (i !== currentIndex) {
                        slide.classList.remove('prev');
                    }
                });
            }, 800);
        }
        
        // Function to go to next slide
        function nextSlide() {
            showSlide(currentIndex + 1);
        }
        
        // Function to go to previous slide
        function prevSlide() {
            showSlide(currentIndex - 1);
        }
        
        // Set up autoplay
        function startAutoplay() {
            if (autoplay && slides.length > 1) {
                autoplayInterval = setInterval(nextSlide, autoplaySpeed);
            }
        }
        
        function stopAutoplay() {
            clearInterval(autoplayInterval);
        }
        
        // Initialize autoplay
        startAutoplay();
        
        // Pause on hover if enabled
        if (pauseOnHover) {
            slider.addEventListener('mouseenter', stopAutoplay);
            slider.addEventListener('mouseleave', startAutoplay);
        }
        
        // Set up arrow navigation
        if (prevArrow) {
            prevArrow.addEventListener('click', function() {
                prevSlide();
                if (autoplay) {
                    stopAutoplay();
                    startAutoplay();
                }
            });
        }
        
        if (nextArrow) {
            nextArrow.addEventListener('click', function() {
                nextSlide();
                if (autoplay) {
                    stopAutoplay();
                    startAutoplay();
                }
            });
        }
        
        // Set up dot navigation
        dots.forEach((dot, index) => {
            dot.addEventListener('click', function() {
                showSlide(index);
                if (autoplay) {
                    stopAutoplay();
                    startAutoplay();
                }
            });
        });
        
        // Set up touch/drag functionality
        if (enableDrag) {
            slider.addEventListener('touchstart', function(e) {
                touchStartX = e.changedTouches[0].screenX;
            }, { passive: true });
            
            slider.addEventListener('touchend', function(e) {
                touchEndX = e.changedTouches[0].screenX;
                handleSwipe();
            }, { passive: true });
            
            // For mouse drag (desktop)
            let isDragging = false;
            
            slider.addEventListener('mousedown', function(e) {
                isDragging = true;
                touchStartX = e.screenX;
                e.preventDefault();
            });
            
            slider.addEventListener('mousemove', function(e) {
                if (!isDragging) return;
                e.preventDefault();
            });
            
            slider.addEventListener('mouseup', function(e) {
                if (!isDragging) return;
                touchEndX = e.screenX;
                isDragging = false;
                handleSwipe();
            });
            
            slider.addEventListener('mouseleave', function(e) {
                if (!isDragging) return;
                touchEndX = e.screenX;
                isDragging = false;
                handleSwipe();
            });
        }
        
        function handleSwipe() {
            const swipeThreshold = 50; // Minimum distance to register as a swipe
            const swipeDistance = touchEndX - touchStartX;
            
            if (swipeDistance > swipeThreshold) {
                // Swiped right, go to previous slide
                prevSlide();
            } else if (swipeDistance < -swipeThreshold) {
                // Swiped left, go to next slide
                nextSlide();
            }
            
            if (autoplay && Math.abs(swipeDistance) > swipeThreshold) {
                stopAutoplay();
                startAutoplay();
            }
        }
        
        // Handle keyboard navigation
        document.addEventListener('keydown', function(e) {
            if (slider.getBoundingClientRect().top < window.innerHeight && 
                slider.getBoundingClientRect().bottom > 0) { // Only if slider is in viewport
                if (e.key === 'ArrowLeft') {
                    prevSlide();
                    if (autoplay) {
                        stopAutoplay();
                        startAutoplay();
                    }
                } else if (e.key === 'ArrowRight') {
                    nextSlide();
                    if (autoplay) {
                        stopAutoplay();
                        startAutoplay();
                    }
                }
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();
})();
